import {propertyTypes} from "@/services/properties";

const properties = {

  prodottoProperty: {
    code: "1a",
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  piuTariffeProperty: {
    code: "",
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatoProperty: {
    code: "1c",
    name: "Codice prodotti collegati",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: "2",
    extCode: "",
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: "3",
    name: "Canale",
    description: "",
    order: 4,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: "4",
    name: "Distributori",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  modDistribuzioneProperty: {
    code: "5",
    name: "Modalità di distribuzione",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: "6",
    name: "Mercato",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  destinatariProperty: {
    code: "7",
    name: "Destinatari",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  targetMarketProperty: {
    code: "8",
    name: "Target Market",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  descProdottoProperty: {
    code: "9",
    name: "Descrizione prodotto",
    description: "",
    order: 10,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  lineaBusinessProperty: {
    code: "10",
    name: "Linea di business",
    description: "",
    order: 11,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieMobilitaProperty: {
    code: "11",
    name: "Tipologia garanzie Mobilita",
    description: "",
    order: 12,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranziePersonaProperty: {
    code: "12",
    name: "Tipologia garanzie Persona",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieCasaEFamigliaProperty: {
    code: "13",
    name: "Tipologia garanzie Casa e Famiglia",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieAziendaProperty: {
    code: "14",
    name: "Tipologia garanzie Azienda",
    description: "",
    order: 15,
    value: "",
    values: [] as any,
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieProfessionistiProperty: {
    code: "15",
    name: "Tipologia garanzie Professionisti",
    description: "",
    order: 16,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: "16",
    name: "Prodotto in commercio",
    description: "",
    order: 17,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: "17",
    name: "Inizio commercializzazione",
    description: "",
    order: 18,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: "18",
    name: "Fine commercializzazione",
    description: "",
    order: 19,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: "19",
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 20,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipoAssicurazioneProperty: {
    code: "20",
    name: "Tipologia di assicurazione",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  durataProperty: {
    code: "21a",
    name: "Durata contrattuale",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tacitoRinnovoProperty: {
    code: "21b",
    name: "Tacito rinnovo",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combGaranzieTipologiaProperty: {
    code: "22",
    name: "Combinazione garanzie - Tipologia",
    description: "",
    order: 24,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combGaranzieDescProperty: {
    code: "23",
    name: "Combinazione garanzie - Descrizione",
    description: "",
    order: 25,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioTipologiaProperty: {
    code: "24",
    name: "Premio - Tipologia",
    description: "",
    order: 26,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioDescProperty: {
    code: "25",
    name: "Premio - Descrizione",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  frazPremioProperty: {
    code: "26",
    name: "Frazionamento del premio",
    description: "",
    order: 28,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  interessiFrazProperty: {
    code: "27",
    name: "Interessi di frazionamento",
    description: "",
    order: 29,
    value: "",
    values: [],
    valueDescription: "",
    frazionamento: {
      mensile: "", mensileSign: "%",
      bimestrale: "", bimestraleSign: "%",
      trimestrale: "", trimestraleSign: "%",
      quadrimestrale: "", quadrimestraleSign: "%",
      semestrale: "", semestraleSign: "%",
    },
    type: propertyTypes.FRAZIONAMENTO,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  retrDistrProperty: {
    code: "28a",
    name: "Retrocessione alla distribuzione",
    description: "",
    order: 30,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  retrDistrSpecificheProperty: {
    code: "28b",
    name: "Retrocessione alla distribuzione - Specifiche",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  rischiAssicuratiMobilitaProperty: {
    code: "29",
    name: "Rischi assicurati Mobilità",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  infortuniSuMezziSharingProperty: {
    code: "30a",
    name: "Infortuni su mezzi sharing",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  infortuniInBiciclettaProperty: {
    code: "30b",
    name: "Infortuni in bicicletta",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  responsabilitaCivileInBiciclettaProperty: {
    code: "30c",
    name: "Responsabilità civile in bicicletta",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  responsabilitaCivileMonopattinoProperty: {
    code: "30d",
    name: "Responsabilità civile per danni da utilizzo di monopattino elettrico",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  tutelaLegaleInBiciclettaProperty: {
    code: "31",
    name: "Tutela legale in bicicletta",
    description: "",
    order: 37,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  furtoBiciclettaProperty: {
    code: "32",
    name: "Furto bicicletta",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  assistenzaBiciclettaTipologiaProperty: {
    code: "33",
    name: "Assistenza bicicletta - Tipologia",
    description: "",
    order: 39,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  assistenzaBiciclettaPeculiaritaProperty: {
    code: "34",
    name: "Assistenza bicicletta - Peculiarità",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  danniCausatiATerziInMobilitaProperty: {
    code: "35",
    name: "Danni causati a terzi in mobilità",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  infortuniSuMezziPubbliciProperty: {
    code: "36",
    name: "Infortuni su mezzi pubblici",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  infortuniInViaggioProperty: {
    code: "37",
    name: "Infortuni in viaggio",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  rimborsoSpeseMedicheInViaggioProperty: {
    code: "38",
    name: "Rimborso spese mediche in viaggio",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  furtoInViaggioProperty: {
    code: "39",
    name: "Furto in viaggio",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  furtoBagaglioProperty: {
    code: "40a",
    name: "Furto bagaglio",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  annullamentoViaggioProperty: {
    code: "40b",
    name: "Annullamento viaggio",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  assistenzaInViaggioTipologiaProperty: {
    code: "41",
    name: "Assistenza in viaggio - Tipologia",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  assistenzaInViaggioPeculiaritaProperty: {
    code: "42",
    name: "Assistenza in viaggio - Peculiarità",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  altreGaranzieMobilitaProperty: {
    code: "43",
    name: "Altre garanzie Mobilità",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Mobilità",
    sectionIndex: 2
  },
  // Persona
  rischiAssicuratiPersonaProperty: {
    code: "44",
    name: "Rischi assicurati Persona",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Persona",
    sectionIndex: 3
  },
  morteDaInfortunioProperty: {
    code: "45",
    name: "Morte da infortunio",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  invaliditaPermanenteDaInfortunioProperty: {
    code: "46",
    name: "Invalidità permanente da infortunio",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaInfortunioProperty: {
    code: "47",
    name: "Inabilità temporanea da infortunio",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  infortunioConIndennizzoForfettarioProperty: {
    code: "48",
    name: "Infortunio con indennizzo forfettario",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  morteDaMalattiaProperty: {
    code: "49",
    name: "Morte da malattia",
    description: "",
    order: 56,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  invaliditaPermanenteDaMalattiaProperty: {
    code: "50",
    name: "Invalidità permanente da malattia",
    description: "",
    order: 57,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaMalattiaProperty: {
    code: "51",
    name: "Inabilità temporanea da malattia",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  graviPatologieMalattieGraviProperty: {
    code: "52a",
    name: "Gravi patologie (Malattie gravi)",
    description: "",
    order: 59,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  cureOncologicheProperty: {
    code: "52b",
    name: "Cure oncologiche",
    description: "",
    order: 60,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  diariaDaRicoveroDaInfortunioMalattiaProperty: {
    code: "53",
    name: "Diaria da ricovero da infortunio/malattia",
    description: "",
    order: 61,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  diariaDaConvalescenzaProperty: {
    code: "54a",
    name: "Diaria da convalescenza",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  diariaDaImmobilizzazioneProperty: {
    code: "54b",
    name: "Diaria da immobilizzazione",
    description: "",
    order: 63,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  rimborsoSpeseMedicheGenericheProperty: {
    code: "55",
    name: "Rimborso spese mediche generiche",
    description: "",
    order: 64,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  rimborsoSpeseMedichePerGrandeInterventoChirurgicoProperty: {
    code: "56",
    name: "Rimborso spese mediche per grande intervento chirurgico",
    description: "",
    order: 65,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  rimborsoSpeseMedichePerRicoveroOInterventoChirurgicoInGenereProperty: {
    code: "57",
    name: "Rimborso spese mediche per ricovero o intervento chirurgico in genere",
    description: "",
    order: 66,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  visiteSpecialisticheEAccertamentiDiagnosticiProperty: {
    code: "58a",
    name: "Visite specialistiche e accertamenti diagnostici",
    description: "",
    order: 67,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  prestazioniAltaSpecializzazioneProperty: {
    code: "58b",
    name: "Prestazioni di alta specializzazione",
    description: "",
    order: 68,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  trattamentiFisioterapiciRieducativiProperty: {
    code: "58c",
    name: "Trattamenti fisioterapici rieducativi",
    description: "",
    order: 69,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  interventoChirurgicoConIndennizzoForfettarioProperty: {
    code: "59",
    name: "Intervento chirurgico con indennizzo forfettario",
    description: "",
    order: 70,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  graviRicoveriConIndennizzoForfettarioProperty: {
    code: "60",
    name: "Gravi ricoveri con indennizzo forfettario",
    description: "",
    order: 71,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  statoDiNonAutosufficienzaProperty: {
    code: "61a",
    name: "Stato di non autosufficienza",
    description: "",
    order: 72,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  statoDiNonAutosufficienzaTemporaneaProperty: {
    code: "61b",
    name: "Stato di non autosufficienza temporanea",
    description: "",
    order: 73,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  cureDentarieProperty: {
    code: "62",
    name: "Cure dentarie",
    description: "",
    order: 74,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  assistenzaAllaPersonaTipologiaProperty: {
    code: "63",
    name: "Assistenza alla persona - Tipologia",
    description: "",
    order: 75,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Persona",
    sectionIndex: 3
  },
  assistenzaAllaPersonaPeculiaritaProperty: {
    code: "64",
    name: "Assistenza alla persona - Peculiarità",
    description: "",
    order: 76,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  esamiDiPrevenzioneCheckUpProperty: {
    code: "65",
    name: "Esami di prevenzione (Check-up)",
    description: "",
    order: 77,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  danniEsteticiProperty: {
    code: "66",
    name: "Danni estetici",
    description: "",
    order: 78,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  lentiCorrettiveDaVistaProperty: {
    code: "67",
    name: "Lenti correttive da vista",
    description: "",
    order: 79,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  tutelaLegalePersonaTipologiaProperty: {
    code: "68",
    name: "Tutela legale persona - Tipologia",
    description: "",
    order: 80,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Persona",
    sectionIndex: 3
  },
  tutelaLegalePersonaPeculiaritaProperty: {
    code: "69",
    name: "Tutela legale persona - Peculiarità",
    description: "",
    order: 81,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  altreGaranziePersonaProperty: {
    code: "70",
    name: "Altre garanzie Persona",
    description: "",
    order: 82,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  limitiDiEtaProperty: {
    code: "71",
    name: "Limiti di età",
    description: "",
    order: 83,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  carenzeProperty: {
    code: "72",
    name: "Carenze",
    description: "",
    order: 84,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Persona",
    sectionIndex: 3
  },
  // Casa e Famiglia
  rischiAssicuratiCasaEFamigliaProperty: {
    code: "73",
    name: "Rischi assicurati Casa e Famiglia",
    description: "",
    order: 85,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  incendioMutuiCasaEFamigliaProperty: {
    code: "74",
    name: "Incendio - Mutui",
    description: "",
    order: 86,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  incendioFabbricatoCasaEFamigliaProperty: {
    code: "75",
    name: "Incendio - Fabbricato",
    description: "",
    order: 87,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  incendioContenutoCasaEFamigliaProperty: {
    code: "76",
    name: "Incendio - Contenuto",
    description: "",
    order: 88,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  incendioAltriRischiCasaEFamigliaTipologiaProperty: {
    code: "77",
    name: "Incendio - Altri rischi - Tipologia",
    description: "",
    order: 89,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  incendioAltriRischiCasaEFamigliaPeculiaritaProperty: {
    code: "78",
    name: "Incendio - Altri rischi - Peculiarità",
    description: "",
    order: 90,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  ricorsoTerziCasaEFamigliaProperty: {
    code: "79",
    name: "Ricorso terzi",
    description: "",
    order: 91,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  rischiCatastrofaliTerremotoCasaEFamigliaProperty: {
    code: "80",
    name: "Rischi catastrofali - Terremoto",
    description: "",
    order: 92,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  rischiCatastrofaliAlluvioneInondazioneCasaEFamigliaProperty: {
    code: "81",
    name: "Rischi catastrofali - Alluvione/Inondazione",
    description: "",
    order: 93,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  RCProprietaDelFabbricatoCasaEFamigliaProperty: {
    code: "82",
    name: "RC - Proprietà del fabbricato",
    description: "",
    order: 94,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  RCConduzioneProperty: {
    code: "83",
    name: "RC - Conduzione",
    description: "",
    order: 95,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  RCVitaPrivataProperty: {
    code: "84",
    name: "RC - Vita privata",
    description: "",
    order: 96,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  RCRCOCasaEFamigliaProperty: {
    code: "85",
    name: "RC - RCO",
    description: "",
    order: 97,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  RCAltriRischiCasaEFamigliaProperty: {
    code: "86",
    name: "RC - Altri rischi",
    description: "",
    order: 98,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  cristalliProperty: {
    code: "87",
    name: "Cristalli",
    description: "",
    order: 99,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  furtoERapinaCasaEFamigliaProperty: {
    code: "88",
    name: "Furto e rapina",
    description: "",
    order: 100,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  assistenzaCasaEFamigliaTipologiaProperty: {
    code: "89",
    name: "Assistenza casa e famiglia - Tipologia",
    description: "",
    order: 101,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  assistenzaCasaEFamigliaPeculiaritaProperty: {
    code: "90",
    name: "Assistenza casa e famiglia - Peculiarità",
    description: "",
    order: 102,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  tutelaLegaleCasaEFamigliaTipologiaProperty: {
    code: "91",
    name: "Tutela legale casa e famiglia - Tipologia",
    description: "",
    order: 103,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  tutelaLegaleCasaEFamigliaPeculiaritaProperty: {
    code: "92",
    name: "Tutela legale casa e famiglia - Peculiarità",
    description: "",
    order: 104,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  elettronicaCasaEFamigliaProperty: {
    code: "93",
    name: "Elettronica",
    description: "",
    order: 105,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  rischiTecnologiciCasaEFamigliaTipologiaProperty: {
    code: "94",
    name: "Cyber risk/Rischi tecnologici casa e famiglia - Tipologia",
    description: "",
    order: 106,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  rischiTecnologiciCasaEFamigliaPeculiaritaProperty: {
    code: "95",
    name: "Cyber risk/Rischi tecnologici casa e famiglia - Peculiarità",
    description: "",
    order: 107,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  animaliDomesticiCasaEFamigliaTipologiaProperty: {
    code: "96",
    name: "Animali domestici - Tipologia",
    description: "",
    order: 108,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  animaliDomesticiCasaEFamigliaPeculiaritaProperty: {
    code: "97",
    name: "Animali domestici - Peculiarità",
    description: "",
    order: 109,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  altreGaranzieCasaEFamigliaProperty: {
    code: "98",
    name: "Altre garanzie Casa e Famiglia",
    description: "",
    order: 110,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Casa e Famiglia",
    sectionIndex: 4
  },
  // Azienda
  rischiAssicuratiAziendaProperty: {
    code: "99",
    name: "Rischi assicurati Azienda",
    description: "",
    order: 111,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  incendioMutuiAziendaProperty: {
    code: "100",
    name: "Incendio - Mutui",
    description: "",
    order: 112,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  incendioFabbricatoAziendaProperty: {
    code: "101",
    name: "Incendio - Fabbricato",
    description: "",
    order: 113,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  incendioContenutoAziendaProperty: {
    code: "102",
    name: "Incendio - Contenuto",
    description: "",
    order: 114,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  incendioAltriRischiAziendaTipologiaProperty: {
    code: "103",
    name: "Incendio - Altri rischi - Tipologia",
    description: "",
    order: 115,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  incendioAltriRischiPeculiaritaAziendaProperty: {
    code: "104",
    name: "Incendio - Altri rischi - Peculiarità",
    description: "",
    order: 116,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  ricorsoTerziAziendaProperty: {
    code: "105",
    name: "Ricorso terzi",
    description: "",
    order: 117,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  rischiCatastrofaliTerremotoAziendaProperty: {
    code: "106",
    name: "Rischi catastrofali - Terremoto",
    description: "",
    order: 118,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  rischiCatastrofaliAlluvioneInondazioneAziendaProperty: {
    code: "107",
    name: "Rischi catastrofali - Alluvione/Inondazione",
    description: "",
    order: 119,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  RCProprietaDelFabbricatoAziendaProperty: {
    code: "108",
    name: "RC - Proprietà del Fabbricato",
    description: "",
    order: 120,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  RCRCTAziendaProperty: {
    code: "109",
    name: "RC - RCT",
    description: "",
    order: 121,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  RCRCOAziendaProperty: {
    code: "110",
    name: "RC - RCO",
    description: "",
    order: 122,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  RCAltriRischiAziendaTipologiaProperty: {
    code: "111",
    name: "RC - Altri Rischi - Tipologia",
    description: "",
    order: 123,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  RCAltriRischiPeculiaritaAziendaProperty: {
    code: "112",
    name: "RC - Altri Rischi - Peculiarità",
    description: "",
    order: 124,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  furtoERapinaAziendaProperty: {
    code: "113",
    name: "Furto e rapina",
    description: "",
    order: 125,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  assistenzaAziendaTipologiaProperty: {
    code: "114",
    name: "Assistenza azienda - Tipologia",
    description: "",
    order: 126,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  assistenzaAziendaPeculiaritaProperty: {
    code: "115",
    name: "Assistenza azienda - Peculiarità",
    description: "",
    order: 127,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  tutelaLegaleAziendaTipologiaProperty: {
    code: "116",
    name: "Tutela legale azienda - Tipologia",
    description: "",
    order: 128,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  tutelaLegaleAziendaPeculiaritaProperty: {
    code: "117",
    name: "Tutela legale azienda - Peculiarità",
    description: "",
    order: 129,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  elettronicaAziendaProperty: {
    code: "118",
    name: "Elettronica",
    description: "",
    order: 130,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  danniIndirettiAziendaProperty: {
    code: "119",
    name: "Danni indiretti",
    description: "",
    order: 131,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  vetriEInsegneAziendaProperty: {
    code: "120",
    name: "Vetri e insegne",
    description: "",
    order: 132,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  rischiTecnologiciAziendaTipologiaProperty: {
    code: "121",
    name: "Cyber risk/Rischi tecnologici azienda - Tipologia",
    description: "",
    order: 133,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  rischiTecnologiciAziendaPeculiaritaProperty: {
    code: "122",
    name: "Cyber risk/Rischi tecnologici azienda - Peculiarità",
    description: "",
    order: 134,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  altreGaranzieAziendaProperty: {
    code: "123",
    name: "Altre garanzie Azienda",
    description: "",
    order: 135,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Azienda",
    sectionIndex: 5
  },
  // Professionisti
  rischiAssicuratiProfessionistiProperty: {
    code: "124",
    name: "Rischi assicurati Professionisti",
    description: "",
    order: 136,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaTecnicaProperty: {
    code: "125",
    name: "RC professionale (area tecnica)",
    description: "",
    order: 137,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaTecnicaAltriRischiTipologiaProperty: {
    code: "126",
    name: "RC professionale (area tecnica) - Altri Rischi - Tipologia",
    description: "",
    order: 138,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaTecnicaAltriRischiPeculiaritaProperty: {
    code: "127",
    name: "RC professionale (area tecnica) - Altri Rischi - Peculiarità",
    description: "",
    order: 139,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaEconomicaGiuridicaProperty: {
    code: "128",
    name: "RC professionale (area economica-giuridica)",
    description: "",
    order: 140,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaEconomicaGiuridicaAltriRischiTipologiaProperty: {
    code: "129",
    name: "RC professionale (area economica-giuridica) - Altri Rischi - Tipologia",
    description: "",
    order: 141,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaEconomicaGiuridicaAltriRischiPeculiaritaProperty: {
    code: "130",
    name: "RC professionale (area economica-giuridica) - Altri Rischi - Peculiarità",
    description: "",
    order: 142,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaMedicaProperty: {
    code: "131",
    name: "RC professionale (area medica)",
    description: "",
    order: 143,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaMedicaAltriRischiTipologiaProperty: {
    code: "132",
    name: "RC professionale (area medica)  - Altri Rischi - Tipologia",
    description: "",
    order: 144,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAreaMedicaAltriRischiPeculiaritaProperty: {
    code: "133",
    name: "RC professionale (area medica)  - Altri Rischi - Peculiarità",
    description: "",
    order: 145,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProfAltraAreaProperty: {
    code: "134",
    name: "RC professionale (altra area)",
    description: "",
    order: 146,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCRCTProfessionistiProperty: {
    code: "135",
    name: "RC - RCT",
    description: "",
    order: 147,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCRCOProfessionistiProperty: {
    code: "136",
    name: "RC - RCO",
    description: "",
    order: 148,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  RCProprietaEConduzioneProperty: {
    code: "137",
    name: "RC - Proprietà e conduzione",
    description: "",
    order: 149,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  assistenzaProfessionistiProperty: {
    code: "138",
    name: "Assistenza professionisti",
    description: "",
    order: 150,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  tutelaLegaleProfessionistiProperty: {
    code: "139",
    name: "Tutela legale professionisti",
    description: "",
    order: 151,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  rischiTecnologiciProfessionistiProperty: {
    code: "140",
    name: "Cyber risk/Rischi tecnologici professionisti",
    description: "",
    order: 152,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  infortuniProperty: {
    code: "141",
    name: "Infortuni",
    description: "",
    order: 153,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  incendioEDanniAllaProprietaProperty: {
    code: "142",
    name: "Incendio e danni alla proprietà",
    description: "",
    order: 154,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  furtoERapinaProfessionistiProperty: {
    code: "143",
    name: "Furto e rapina",
    description: "",
    order: 155,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  elettronicaProfessionistiProperty: {
    code: "144",
    name: "Elettronica",
    description: "",
    order: 156,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  vetriECristalliProfessionistiProperty: {
    code: "145",
    name: "Vetri e cristalli",
    description: "",
    order: 157,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  altreGaranzieProfessionistiProperty: {
    code: "146",
    name: "Altre garanzie Professionisti",
    description: "",
    order: 158,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Professionisti",
    sectionIndex: 6
  },
  // Innovazione
  innovazioneProperty: {
    code: "147a",
    name: "Innovazione",
    description: "",
    order: 159,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Innovazione",
    sectionIndex: 7
  },
  // Note
  noteProperty: {
    code: "147b",
    name: "Note",
    description: "",
    order: 160,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 8
  },
  codProdottoProperty: {
    code: "148",
    name: "Codice prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
};

export default properties;
